import DataTable from "@/components/admin/DataTable";
import { adminApi } from "@/lib/adminApi";

const columns = [
  { key: "created_at", label: "Reçu le", format: "date" },
  {
    key: "nom",
    label: "Contact",
    render: (it) => (
      <div>
        <div className="font-medium">{it.nom}</div>
        <div className="text-xs text-[#5F6170] mt-0.5">{it.email}</div>
        {it.telephone && (
          <div className="text-xs text-[#5F6170]">{it.telephone}</div>
        )}
      </div>
    ),
  },
  {
    key: "type_demande",
    label: "Type",
    render: (it) => (
      <span className="text-xs text-[#3A2E6E]">{it.type_demande || "—"}</span>
    ),
  },
  {
    key: "message",
    label: "Message",
    render: (it) => (
      <div className="max-w-md text-xs text-[#5F6170] whitespace-pre-wrap">
        {it.message}
      </div>
    ),
  },
];

export default function ContactsList() {
  return (
    <DataTable
      testId="admin-contacts"
      title="Demandes de rendez-vous"
      subtitle="Formulaire de contact (prise de RDV individuel)."
      fetcher={adminApi.listContacts}
      columns={columns}
    />
  );
}
